import WFHelper from './WFHelper'
import * as WFC from './WFConstants'

/**
 * Created by Xuz on 2020/01/14.
 * xuz@live.cn
 *
 * 连接线
 */
const uuidv4 = require('uuid/v4')

class WFLink {
  _init () {
    this.sType = 1
    this.sUuid = uuidv4()
    this.bKilled = false
    this.bCreated = false

    this.dSvg = null
    this.dLine = null
    this.dText = null

    this.dOutLine = null

    this.sAttrName = null
    this.sRouteType = null

    this.sLinkStartEl = null
    this.sLinkEndEl = null
    this.iOrder = null

    this.dLastOverNode = null
  }

  constructor (workflow) {
    this._init()
    this.workflow = workflow
  }

  getType () {
    return this.sType
  }

  uuid () {
    return this.sUuid
  }

  getName () {
    return this.sAttrName
  }

  getStart () {
    return this.sLinkStartEl
  }

  getEnd () {
    return this.sLinkEndEl
  }

  /**
   * 获得路径类别
   */
  getRouteType () {
    return this.sRouteType
  }

  setName (name) {
    this.sAttrName = name
    this._setSvgName(name)
  }

  setOrder (orderNo) {
    this.iOrder = orderNo
    this.dSvg.attr('wf-link-order', this.iOrder)
  }

  setStart (el) {
    this.sLinkStartEl = el.uuid()
  }

  setEnd (el) {
    this.sLinkEndEl = el.uuid()
  }

  getLine () {
    return this.dLine
  }

  createPos (x, y, x1, y1) {
    return 'M ' + x + ',' + y + ' L ' + x1 + ',' + y1
  }

  create (event, el) {
    const oSvgJs = this.workflow.getSvgJs()
    const lineId = 'line_' + this.sUuid

    let elSvg = el.getSvg()
    let elPos = WFHelper.getElementCenterPos(elSvg)

    this.dSvg = oSvgJs.group()

    this.dLine = oSvgJs.path()
    let pathPos = this.createPos(elPos.x, elPos.y, elPos.x, elPos.y)
    this.dLine.attr('stroke-width', '1.3')
    this.dLine.attr('d', pathPos)
    this.dLine.attr('marker-end', 'url(#arrow)')
    this.dLine.attr('stroke', 'black')
    this.dLine.attr('cursor', 'move')
    this.dLine.attr('fill', 'none')
    this.dLine.attr('uuid', this.sUuid)
    this.dLine.attr('id', lineId)

    this.sAttrName = WFHelper.getNextLinkName()

    this.dText = oSvgJs.text('')
    // this.dTextPath = oSvgJs.textPath()
    // this.dTspan = this.dText.tspan(this.sAttrName)
    // this.dTspan.attr('uuid', this.sUuid)
    // this.dTspan.attr('dy', '-4')
    // this.dTspan.attr('dx', '0')
    // this.dTspan.attr('style', 'fill:black;text-anchor:middle;font-size:14;font-family:sans-serif')
    // this.dTextPath.add(this.dTspan)
    // this.dText.add(this.dTextPath)

    // this.dLine.text(this.sAttrName)
    // this.dLine.attr('startOffset', '50%')
    this._setSvgName(this.sAttrName)

    this.dSvg.add(this.dLine)
    this.dSvg.add(this.dText)

    oSvgJs.add(this.dSvg)
    this.workflow.bringToFront(el.getSvg())
    this.workflow.registerElement(this)
  }

  onMove (event) {
    if (!this.workflow.isMouseDowning()) {
      return
    }
    if (this.dLastOverNode != null) {
      this.dLastOverNode.onLinkerOut(event)
      this.workflow.setMessage(null)
      this.dLastOverNode = null
    }
    this.workflow.setDrawLink(true)
    let pos = WFHelper.getPos(event, this.workflow.getCTM())
    let lastElPos = WFHelper.getElementCenterPos(this.workflow.getLastElement().getSvg())
    let pathPos = this.createPos(lastElPos.x, lastElPos.y, pos.x, pos.y)
    this.dLine.attr('d', pathPos)

    let node = this.workflow.getOverNode(event)
    if (node == null || node === this.workflow.getLastElement()) {
      return
    }

    // 修改指向的实体的样子
    node.onLinkerOver(event)
    this.dLastOverNode = node
  }

  /**
   * 画线结束
   * @param event
   */
  onUp (event) {
    // 按住鼠标左键拖动过程中按下右键
    if (this.workflow.isDrawLink() && event.button !== 0) {
      return
    }
    if (this.dLastOverNode != null) {
      this.dLastOverNode.onLinkerOut(event)
      this.dLastOverNode = null
    }
    if (!this.workflow.isDrawLink()) {
      return
    }
    this.workflow.setDrawLink(false)
    if (this.bKilled) {
      this.bKilled = false
      return
    }
    let node = this.workflow.getOverNode(event)
    // 如果没指向对象或者指向自己都不画线
    if (node == null || node === this.workflow.getLastElement()) {
      this.remove()
      // 如果没画成功就不画了，但名称服务要减少
      WFHelper.decrLinkName()
    } else {
      this.sLinkStartEl = this.workflow.getLastElement().uuid()
      this.sLinkEndEl = node.uuid()

      // 如果已经有此路径被建立了
      if (this.workflow.isRoadCreated(this.sLinkStartEl, this.sLinkEndEl)) {
        this.bKilled = false
        this.dSvg.remove()
        return
      }

      // 如果路径指向起点是不合法的
      let startNode = this.workflow.getStartNode()
      if (startNode != null) {
        if (this.sLinkEndEl === startNode.uuid()) {
          this.bKilled = true
          this.dSvg.remove()
          return
        }

        // 如果起点是起点，结点不是普通节点的话不合法
        if (this.sLinkStartEl === startNode.uuid()) {
          if (node.getType() !== WFC.NODE_TYPE_COMMON_NODE) {
            this.bKilled = true
            this.dSvg.remove()
            return
          }
        }
      }

      // 合法的连线
      let endPos = WFHelper.getElementCenterPos(node.getSvg())
      let endRect = WFHelper.getRect(node.getSvg())
      let startPos = WFHelper.getElementCenterPos(this.workflow.getLastElement().getSvg())
      let fixPos = WFHelper.fixLinkPos(startPos, endPos, endRect)
      let pathPos = this.createPos(startPos.x, startPos.y, fixPos.x, fixPos.y)

      this.dLine.attr('d', pathPos)
      this.workflow.setRoad(this.sLinkStartEl, this.sLinkEndEl, this)

      // 当路真正被创建后，调用可被恢复的序列化方法
      this.serial()

      // 路径的建立与普通的不同，其真正的建立在连线彻底成功之后才执行
      const wfXml = this.workflow.getWfXml()
      wfXml.addRoute(this)

      this.bCreated = true
    }
  }

  nextType () {
    if (!this.bCreated) {
      return
    }
  }

  onToolbarChange () {
  }

  onTrackStyle () {
    this.dLine.attr('stroke', 'red')
    this.dLine.attr('marker-end', 'url(#redArrow)')
  }

  /**
   * 移除自己
   */
  remove () {
    if (this.bKilled) {
      return
    }
    this.workflow.clearRoad(this.sLinkStartEl, this.sLinkEndEl, this)
    this.sLinkStartEl = null
    this.sLinkEndEl = null
    this.bKilled = true
    this.dSvg.remove()
    this.workflow.unregisterElement(this)
  }

  /**
   * 检查本连接是否连接着指定的两个点
   */
  isRoad (startElId, endElId) {
    return this.sLinkStartEl === startElId && this.sLinkEndEl === endElId
  }

  serial () {
    this.dSvg.attr('uuid', this.sUuid)
    this.dSvg.attr('wf-class', 'WFLink')
    this.dSvg.attr('wf-link-start', this.sLinkStartEl)
    this.dSvg.attr('wf-link-end', this.sLinkEndEl)
    this.dSvg.attr('link-type', this.sType)
    this.iOrder = this.iOrder == null ? '' : this.iOrder
    this.dSvg.attr('wf-link-order', this.iOrder)
  }

  getXmlNode (oXml) {
    let node = oXml.createElement('route')
    node.setAttribute('uuid', this.sUuid)
    node.setAttribute('name', this.sAttrName)
    node.setAttribute('start', this.sLinkStartEl)
    node.setAttribute('end', this.sLinkEndEl)
    let r = this.iOrder == null ? '' : this.iOrder
    node.setAttribute('order', r)

    return node
  }

  onSelect (event) {
    let rect = WFHelper.getRect(this.dSvg)
    WFHelper.extendRect(rect, 6)
    const oSvgJs = this.workflow.getSvgJs()
    this.dOutLine = oSvgJs.rect()
    this.dOutLine.attr('uuid', this.sUuid)
    this.dOutLine.attr('x', rect.x)
    this.dOutLine.attr('y', rect.y)
    this.dOutLine.attr('width', rect.width)
    this.dOutLine.attr('height', rect.height)
    this.dOutLine.attr('style', 'stroke-dasharray:3.3;stroke:black;stroke-width:1;fill:white;opacity:0.8')
    this.dOutLine.insertBefore(this.dText)

    this.workflow.bringToFront(this.dSvg)
    // 线被提前后，其关联的节点也需要被提前
    this.workflow.bringToFront(this.workflow.getElement(this.sLinkStartEl).getSvg())
  }

  onUnSelect (event) {
    if (this.dOutLine == null) {
      return
    }
    this.dOutLine.remove()
    this.dOutLine = null
  }

  /**
   * 关联线条移动，当其本身的两头节点移到时，线需要重画，该方法由节点本身事件分发时控制
   */
  relateMove (uuid) {
    let startEl = this.workflow.getElement(this.sLinkStartEl).getSvg()
    let endEl = this.workflow.getElement(this.sLinkEndEl).getSvg()
    let endPos = WFHelper.getElementCenterPos(endEl)
    let endRect = WFHelper.getRect(endEl)
    let startPos = WFHelper.getElementCenterPos(startEl)
    let pathPos = null
    let fixPos = WFHelper.fixLinkPos(startPos, endPos, endRect)
    pathPos = this.createPos(startPos.x, startPos.y, fixPos.x, fixPos.y)

    this.dLine.attr('d', pathPos)
    // TODO 修正文字的位置
  }

  onMouseDblClick (event) {
    let parent = this.workflow.getParent()
    parent.onEditLinkNode(this)
  }

  setWFAttributes (attrName, value) {
    const wfXml = this.workflow.getWfXml()
    if (attrName === 'FORM') {
      const oXml = wfXml.getXml()
      let nodes = WFHelper.createWFFormAttributesNode(value, oXml)
      let node = wfXml.getNode(this.sUuid)
      WFHelper.removeWFFormAttributes(node)
      for (let i = 0; i < nodes.length; i++) {
        node.appendChild(nodes[i])
      }
    }

    if (attrName === 'ROUTE_TYPE') {
      this.sRouteType = value
    }
  }

  /**
   * 更新节点的描述信息
   */
  updateXmlNode () {
    const wfXml = this.workflow.getWfXml()
    let node = wfXml.getNode(this.sUuid)
    node.setAttribute('name', this.sAttrName)
  }

  pushWFAttributes (formData) {
    const wfXml = this.workflow.getWfXml()
    WFHelper.pushWFFormAttributes(formData, wfXml.getNode(this.sUuid))
  }

  unSerial (svg) {
    this.dSvg = svg
    let children = this.dSvg.children()
    this.sUuid = this.dSvg.attr('uuid')
    this.dLine = children[0]
    this.dText = children[1]
    this.sAttrName = this.dText.children()[0].text()
    this.sLinkStartEl = this.dSvg.attr('wf-link-start')
    this.sLinkEndEl = this.dSvg.attr('wf-link-end')
    this.iOrder = this.dSvg.attr('wf-link-order')

    this.workflow.registerElement(this)
    this.workflow.setRoad(this.sLinkStartEl, this.sLinkEndEl, this)
    this.workflow.getWfXml().addRoute(this)
  }

  onCanGo () {

  }

  _setSvgName (name) {
    const lineId = 'line_' + this.sUuid
    this.dText.tspan(this.sAttrName)
      .attr('uuid', this.sUuid)
      .attr('style', 'fill:black;text-anchor:middle;font-size:14;font-family:sans-serif')
      .dx(0)
      .dy(-4)
    this.dText.path().attr('xlink:href', '#' + lineId).attr('href', '#' + lineId).attr('startOffset', '50%')
  }
}

export default WFLink
